module.exports = __webpack_public_path__ + "img/img-2mobile.9cb6bb7b.png";